import React, { PropTypes } from 'react';
import { FontIcon } from 'material-ui';
import moment from 'moment';
import UncheckedIcon from 'material-ui/svg-icons/toggle/radio-button-unchecked';
import ProductStatus from './single-product-export-status.jsx';

const HistoryFeed = ({ user, timestamp, products }) => (
    <div>
      <div style={{ marginBottom: '5px' }}>
        <UncheckedIcon color="#c8c8c8" style={{ position: 'relative', fontSize: '15px', height: '25px', width: '20px', left: '-11px', top: '-18px', backgroundColor: 'white' }}/>
        <div style={{ display: 'inline-block', marginLeft: '20px' }}>
          <span style={{ display: 'block', fontWeight: '600', fontSize: '14px' }}>{user}</span>
          <span style={{ display: 'block', fontSize: 'small' }}>{moment(timestamp).format('MMMM Do YYYY, h:mm:ss a')}</span>
        </div>
      </div>
      <div style={{ marginLeft: '40px', marginBottom: '24px', border: '1px solid #E6E6E6', padding: '5px 10px' }}>
        { products.map((product, index) => <ProductStatus {...product} key={index} />) }
      </div>
    </div>
);

HistoryFeed.propTypes = {
  user: PropTypes.string,
  timestamp: PropTypes.string,
  products: PropTypes.array,
};

module.exports = HistoryFeed;



// WEBPACK FOOTER //
// ./src/app/components/integration/export/export-history-feed.jsx